var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 0.5H2C1.60218 0.5 1.22064 0.658035 0.93934 0.93934C0.658035 1.22064 0.5 1.60218 0.5 2V5.08437V13.9906C0.5 14.3884 0.658035 14.77 0.93934 15.0513C1.22064 15.3326 1.60218 15.4906 2 15.4906H20C20.3978 15.4906 20.7794 15.3326 21.0607 15.0513C21.342 14.77 21.5 14.3884 21.5 13.9906V2C21.5 1.60218 21.342 1.22064 21.0607 0.93934C20.7794 0.658035 20.3978 0.5 20 0.5ZM11.75 12.5H10.25C10.0511 12.5 9.86032 12.421 9.71967 12.2803C9.57902 12.1397 9.5 11.9489 9.5 11.75C9.5 11.5511 9.57902 11.3603 9.71967 11.2197C9.86032 11.079 10.0511 11 10.25 11H11.75C11.9489 11 12.1397 11.079 12.2803 11.2197C12.421 11.3603 12.5 11.5511 12.5 11.75C12.5 11.9489 12.421 12.1397 12.2803 12.2803C12.1397 12.421 11.9489 12.5 11.75 12.5ZM17.75 12.5H14.75C14.5511 12.5 14.3603 12.421 14.2197 12.2803C14.079 12.1397 14 11.9489 14 11.75C14 11.5511 14.079 11.3603 14.2197 11.2197C14.3603 11.079 14.5511 11 14.75 11H17.75C17.9489 11 18.1397 11.079 18.2803 11.2197C18.421 11.3603 18.5 11.5511 18.5 11.75C18.5 11.9489 18.421 12.1397 18.2803 12.2803C18.1397 12.421 17.9489 12.5 17.75 12.5ZM2 4.33437V2H20V4.33437H2Z",
    fill: "#272727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.6db519d24d0904dfd4d8836552840805.svg";
export { ForwardRef as ReactComponent };